import { Color, Flex, Spacing, TableCellContent, Tag } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface InvoiceDescriptionProps {
  children: ReactNode
  isCreditNote?: boolean
  isFaded?: boolean
  title?: string
}

export const InvoiceDescription = ({
  children,
  isCreditNote,
  isFaded,
  title,
}: InvoiceDescriptionProps): ReactElement => {
  const { t } = useTranslation()

  // The table cell already wraps its content in a paragraph, so the wrappers here are spans to stay valid HTML.
  return (
    <Flex alignItems="center" as="span" gap={Spacing.S8}>
      {isCreditNote && (
        <Tag color={isFaded ? 'neutral' : 'blue'} type="subtle">
          {t('external_invoices.list.table.column.description.credit_note')}
        </Tag>
      )}
      <TableCellContent as="span" color={isFaded ? Color.Grey300 : undefined} inline={false} title={title} truncate>
        {children}
      </TableCellContent>
    </Flex>
  )
}
